<template>
  <v-card height="100%" class="kim-card hover outlined">
    <v-card-title>
      <div class="subtitle-1 text-truncate">
        {{specialist.first_name}} {{specialist.last_name}}
      </div>
      <v-spacer></v-spacer>
      <event-status-chip :event-status="appointment.event_status" />
    </v-card-title>
    <v-card-text class="text-center">
      <v-sheet color="secondary-card pa-3">
        <v-chip outlined small color="primary">
          <v-icon size="18" class="mr-1">mdi-calendar</v-icon>
          {{$moment(appointment.date).format('DD-MM-YYYY')}}
        </v-chip>
        <v-chip small class="ml-1">
          <v-icon>mdi-watch</v-icon>
          {{appointment.time}}
        </v-chip>
      </v-sheet>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          x-small
          color="error"
          v-if="appointment.event_status.id < 2"
          @click.stop="onCancelClick(appointment)"
      >
        <v-icon
            class="mr-1"
            size="16" >mdi-cancel</v-icon>
        Cancelar
      </v-btn>

      <v-btn
          x-small
          color="success"
          v-if="appointment.event_status.id < 2"
          @click.stop="onConfirmClick(appointment)"
      >
        <v-icon
            class="mr-1"
            size="16" >mdi-check</v-icon>
        Confirmar
      </v-btn>

    </v-card-actions>
  </v-card>
</template>
<script>
import EventStatusChip from "@/components/appointments/EventStatusChip";
export default {
  components: {EventStatusChip},
  props: {
    appointment: {
      required: true,
      type: Object
    }
  },
  data() {
    return {

    }
  },
  methods: {
    onCancelClick(appointment){
      this.$emit('click:cancel', appointment)
    },
    onConfirmClick(appointment){
      this.$emit('click:confirm', appointment)
    },
  },
  computed: {
    specialist(){
      const vm = this
      return vm.appointment.schedule.specialist || '-'
    }
  }
}
</script>
<style scoped>

</style>
